import { render, staticRenderFns } from "./RiskManagementTool.vue?vue&type=template&id=67483dba&scoped=true&"
import script from "./RiskManagementTool.vue?vue&type=script&lang=js&"
export * from "./RiskManagementTool.vue?vue&type=script&lang=js&"
import style0 from "./RiskManagementTool.vue?vue&type=style&index=0&id=67483dba&scoped=true&lang=css&"
import style1 from "./RiskManagementTool.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67483dba",
  null
  
)

export default component.exports